/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x2946=['description','string','Position'];(function(_0x36e51b,_0x2946d5){var _0x2e37a3=function(_0x6aed10){while(--_0x6aed10){_0x36e51b['push'](_0x36e51b['shift']());}};_0x2e37a3(++_0x2946d5);}(_0x2946,0x14a));var _0x2e37=function(_0x36e51b,_0x2946d5){_0x36e51b=_0x36e51b-0x0;var _0x2e37a3=_0x2946[_0x36e51b];return _0x2e37a3;};import _0x2a074e from'./operationcompressor';export default class a extends _0x2a074e{static get[_0x2e37('0x0')](){return{'fields':{'position':{'type':_0x2e37('0x2'),'id':0x1},'oldName':{'type':_0x2e37('0x1'),'id':0x2},'newName':{'type':_0x2e37('0x1'),'id':0x3},'wasUndone':{'type':'bool','id':0x4}}};}}